<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.app_name" :error="form.errors.app_name" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('App Name')" />
          <text-input v-model="form.domain" :error="form.errors.domain" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Domain')" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('Logo')" />
          <file-input v-model="form.logo_white" :error="form.errors.logo_white" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('Logo White')" />
          <file-input v-model="form.favicon" :error="form.errors.favicon" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('Favicon')" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('Project') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    title: String,
    roles: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        app_name: null,
        domain: null,
        logo: null,
        logo_white: null,
        favicon: null,
      }),
    }
  },
  created() {
    // this.setDefaultValue(this.countries, 'country_id', 'United States')
  },
  methods: {
    setDefaultValue(arr, key, value){
      const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
      if(find){
        this.form[key] = find['id']
      }
    },
    store() {
      this.form.post(this.route('projects.store'))
    },
  },
}
</script>
